import { Box3, Vector3 } from 'three'

export type VehiclePreviewView = 'iso' | 'front' | 'side' | 'top'

/** Fit the complete rendered vehicle, including cab/attelage, to either screen orientation. */
export function fitVehiclePreviewCamera(bounds: Box3, aspect: number, fov: number, view: VehiclePreviewView) {
  const target = bounds.getCenter(new Vector3())
  const directions: Record<VehiclePreviewView, Vector3> = {
    iso: new Vector3(-.65, .4, 1), front: new Vector3(-1, .12, .03),
    side: new Vector3(-.12, .08, 1), top: new Vector3(0, 1, .001),
  }
  const direction = directions[view].normalize()
  const right = new Vector3(0, 1, 0).cross(direction).normalize()
  const up = direction.clone().cross(right).normalize()
  const tanV = Math.tan(fov * Math.PI / 360), tanH = tanV * Math.max(.1, aspect)
  let distance = .8
  for (const x of [bounds.min.x, bounds.max.x]) for (const y of [bounds.min.y, bounds.max.y]) for (const z of [bounds.min.z, bounds.max.z]) {
    const point = new Vector3(x, y, z).sub(target), depth = point.dot(direction)
    distance = Math.max(distance, depth + Math.abs(point.dot(right)) / tanH * 1.18, depth + Math.abs(point.dot(up)) / tanV * 1.18)
  }
  return { target, position: target.clone().addScaledVector(direction, distance) }
}
